export default "__VITE_ASSET__L5firA0D__"